export default __webpack_public_path__ + "static/media/epias-logo.f0cdbb3d.svg";